import { debounce } from 'lodash-es';
import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * 计算一块的大小
 * @param correctWidth  修正值，像这个元素有边框什么的排除掉，再进行计算
 * @param itemWidth  一个元素最小的宽度
 * @param defaultColSpan  默认的分块，主要怕没有计算前的时候出现问题
 * @returns
 */
export function useResize({
  correctWidth = 0,
  itemWidth,
  defaultColSpan = 8,
}: {
  correctWidth?: number;
  itemWidth: number;
  defaultColSpan?: number;
}) {
  const [colSpan, setColSpan] = useState(defaultColSpan);
  let divRef = useRef<any>(null);

  const calculateColSpan = () => {
    if (divRef.current) {
      const piece = Math.floor(
        (divRef.current.offsetWidth - correctWidth) / itemWidth,
      );
      const span = Math.ceil(24 / piece);
      setColSpan(span === 5 ? 4 : span);
    }
  };

  const refCallback = useCallback((e) => {
    if (e) {
      divRef.current = e;
      calculateColSpan();
    }
  }, []);

  useEffect(() => {
    const resizeFunc = debounce(() => {
      calculateColSpan();
    }, 300);
    window.addEventListener('resize', resizeFunc);

    return () => {
      window.removeEventListener('resize', resizeFunc);
    };
  }, []);

  return {
    colSpan,
    refCallback,
  };
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const handleResize = debounce(() => {
      console.log('window.innerWidth', window.innerWidth);
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 200); // Adjust debounce delay as needed

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { windowSize };
}
